<!--
  Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
  This information is confidential and proprietary to GM Global Technology
  Operations LLC and may not be used, modified, copied or distributed.
  -->
<div id="gm-main-container">
  <router-outlet></router-outlet>
</div>
